const useMobile = () => {
  //@ts-ignore
  const isMobileApp = !!window.cordova;
  return {
    isMobileApp,
  };
};

export default useMobile;
